'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_09e1f5ae = {"row":"Row_module_row__a4913684","sub-row":"Row_module_subRow__a4913684"};
require("../../../assets/cjs/components/Table/src/Row~CqpRqM4R.css");

exports.default = modules_09e1f5ae;
//# sourceMappingURL=Row.module.less.js.map
